<template>
  <div
    class="relative cursor-pointer text-neutral-900 dark:text-neutral-100 select-none py-2 pl-3 pr-9"
    :class="{
      'bg-neutral-200 dark:bg-neutral-800': active,
      disabled,
    }"
  >
    <span
      :class="[selected ? 'font-semibold' : 'font-normal', 'block truncate']"
      >{{ option.text }}</span
    >

    <span
      class="absolute inset-y-0 right-0 flex items-center pr-4 text-neutral-800 dark:text-neutral-200"
    >
      <slot name="icon" v-bind="{ selected }">
        <IconCheck v-if="selected" class="h-5 w-5" aria-hidden="true" />
      </slot>
    </span>
  </div>
</template>

<script
  setup
  lang="ts"
  generic="T extends string | number | undefined | null, V extends object"
>
import type { Props } from "~/components/nami/select/NamiSelectSingle.vue";
import { IconCheck } from "@tabler/icons-vue";

defineProps<{
  selected: boolean;
  option: Props<T, V>["options"][number];
  active: boolean;
  disabled?: boolean;
}>();
</script>
